module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptitle",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('strong', [_c('span', {
    staticClass: "color-7AC39E"
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('hr', {
    staticClass: "hrline"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("1 SCARE TACTICS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 ADVICE THAT STUCK")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 CRAZYTOWN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 WISE WORDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 IT’S FUNNY BECAUSE IT’S TRUE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 COACHES, MENTORS & OTHER UNFORGETTABLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 THE SISTERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 DIFFERENT DRUMMERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 THE OLD STANDARDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 OUCH!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 LIFE CHANGERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/app01#app01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/app02#app02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0